<template>
    <simple-modal
        max-width="max-w-3xl"
        @close="$emit('close')"
        :show="show">
        <loading-indicator v-if="loadingActionSummary && actionItems.length===0"></loading-indicator>

        <div v-else-if="actionItems.length === 0" class="px-6 pt-4 pb-12 text-lg text-center">This inspection has no items with recommendations or tickets</div>

        <div v-else class="px-2 pb-4">
            <div class="sm:flex sm:items-center">
                <div class="sm:flex-auto">
                    <div class="text-xl font-medium text-gray-900">{{ inspection.asset_name }}</div>
                    <div class="text-base text-gray-400"><span class="text-indigo-600 font-medium">{{ inspection.type }} </span>- Inspector Recommendations</div>
                </div>
            </div>
            <div class="mt-8 flex flex-col px-4 sm:px-6 lg:px-8">
                <div class="-my-2 -mx-4 sm:-mx-6 lg:-mx-8">
                    <div
                        class="inline-block min-w-full pb-2 align-middle overflow-y-auto overscroll-none scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-indigo-100 pr-4">
                        <div style="max-height: 400px">
                            <table class="min-w-full border-separate overflow-x-scroll overflow-y-scroll" style="border-spacing: 0; max-height: 200px">
                                <thead class="bg-gray-50 sticky top-0 z-10 bg-gray-50 text-sm  text-gray-900">
                                    <tr>
                                        <th scope="col"
                                            class="border-b border-gray-300 py-3.5 px-2 pr-3 font-semibold text-left backdrop-blur backdrop-filter">Area/Item
                                        </th>
                                        <th scope="col"
                                            class="border-b border-gray-300 px-3 py-3.5 font-semibold text-left backdrop-blur backdrop-filter table-cell">Recommendation
                                        </th>
                                        <th scope="col"
                                            class="border-b border-gray-300 px-3 py-3.5 font-semibold text-left backdrop-blur backdrop-filter table-cell">Tickets
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="bg-white">
                                    <tr v-for="item in actionItems">
                                        <td class="whitespace-nowrap border-b border-gray-200 py-2 px-2 text-sm font-medium text-gray-900">
                                            <div>{{ item.area_name }} {{ item.item }}</div>
                                            <div class="my-1 -ml-1" v-if="item.cleanliness || item.damage || item.functioning">
                                                <span class="bg-indigo-50 text-indigo-600 p-1 rounded-md my-1 mr-1" v-if="item.cleanliness">{{
                                                        item.cleanliness
                                                    }}</span>
                                                <span class="bg-indigo-50 text-indigo-600 p-1 rounded-md my-1 mr-1" v-if="item.damage">{{ item.damage }}</span>
                                                <span class="bg-indigo-50 text-indigo-600 p-1 rounded-md my-1 mr-1" v-if="item.functioning">{{ item.functioning }}</span>
                                            </div>
                                            <div class="text-gray-500 font-normal whitespace-pre-line" v-if="item.comments">{{ item.comments }}</div>
                                        </td>
                                        <td class="font-medium border-b border-gray-200 px-3 py-4 text-sm table-cell">
                                            {{ item.recommendation }}
                                        </td>
                                        <td class="whitespace-nowrap border-b border-gray-200 px-3 py-4 text-sm text-gray-500 table-cell">
                                            <div v-if="item.issues">
                                                <button v-for="issue in item.issues"
                                                        v-if="issue.inspection_ticket"
                                                        @click.prevent="openTicketDashboard(issue.ticket_id)"
                                                        :class="['font-medium priority-' + (issue.inspection_ticket.priority).toLowerCase()]"
                                                        class="block cursor-pointer">
                                                    {{ issue.inspection_ticket.reference_number }} - {{ issue.inspection_ticket.status }}
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- More people... -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </simple-modal>
</template>

<script>
export default {
    name: "InspectionActionsSummary",
    props: {
        show: {
            type: Boolean,
            required: true
        },
        inspection: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            loadingActionSummary: true,
            actionItems: []
        };
    },
    created () {
        this.loadingActionSummary = true;
        axios.get(`/inspections/${this.inspection.id}/items/action-items`)
        .then((response) => {
            this.actionItems = response.data;
            this.loadingActionSummary = false;
        }).catch((error) => {
            toastr.error("Could not fetch recommendation Items: " + error);
            this.loadingActionSummary = false;
        });
    },
    methods: {
        compileItemDescription (item) {
            let values = [];
            values.push(item.cleanliness, item.damage, item.functioning).filter(n => n).join(",");
        },
        openTicketDashboard (ticketId) {
            window.open("/tickets/" + ticketId, "_blank");
        }
    }
};
</script>

<style scoped>
/* width */
.overflow-y-scroll::-webkit-scrollbar {
    width: 5px;
}

/* Track */
.overflow-y-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
.overflow-y-scroll::-webkit-scrollbar-thumb {
    background: #adadad;
}

/* Handle on hover */
.overflow-y-scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
}
</style>
